import {writeStorage} from "../../LocalStorage/helpers/writeStorage";
import {StorageKey} from "../../../enums/StorageKey";
// eslint-disable-next-line import/no-cycle
import {L} from "../reducer";
// import { SubscriptionQuotaDummy, useDummyData as useDummyQuota } from "../../../components/Access/dummy";
import { flowStreamsListV2, useDummyFlowStreamsListV2 } from '../../../containers/AppPage/ControlPanel/Flow/dummy/flowStreamsListV2';

export function updateReducer(key, responseData, params) {
    // Process response data
    const {
        company_addresses,
        contact_addresses,
        contact_persons,
        countries,
        state_list,
        currencies,
        contacts,
        contact_groups,
        // products, // changed to product_list
        accounts,
        terms,
        tag_groups,
        asset_types,
        fields,
        number_formats,
        locations,
        tax_codes,
        settings,
        // limits,
        users,
        price_levels,
        payment_methods,
        advisors,
        clients,
        product_list,
        // product,
        product_detail,
        product_detail_list,
        product_groups,
        classification_code_list,
        form_designs,
        // flow
        flow_streams,
    } = responseData;

    switch (key) {
        case L.company_addresses:
            return {
                companyAddresses: company_addresses.items,
            };
        case L.contact_addresses:
            return {
                contactAddresses: contact_addresses.items,
            };
        case L.contact_persons:
            return {
                contactPersons: contact_persons.items,
            };
        case L.countries:
            return {
                countries: countries.items,
            };
        case L.state_list:
            return {
                countryStates: state_list.items, // [{id, country_code, code, name}, ...]
            };
        case L.currencies:
            if (currencies.not_changed)
                return {};
            return {
                currencyGroups: currencies,
                currencies: currencies.favourite_items
                    .concat(currencies.popular_items)
                    .concat(currencies.other_items),
                currencyVersion: currencies.version,
            };
        case L.contacts:
            if (contacts.not_changed)
                return {};
            return {
                contacts: contacts.items,
                contactVersion: contacts.version,
            };
        case L.contact_groups:
            if (contact_groups.not_changed)
                return {};
            return {
                contactGroups: contact_groups.items,
                contactGroupVersion: contact_groups.version,
            };
        // case L.products:
        //     if (products.not_changed)
        //         return {};
        //     return {
        //         products: products.items,
        //         productVersion: products.version,
        //     };
        case L.accounts:
            if (accounts.not_changed)
                return {};
            return {
                accounts: accounts.items,
                accountVersion: accounts.version,
            };
        case L.terms:
            if (terms.not_changed)
                return {};
            return {
                terms: terms.items,
                termVersion: terms.version,
            };
        case L.tag_groups: {
            if (tag_groups.not_changed)
                return {};

            // Extract all tags under each tag groups
            const tags = tag_groups.items.reduce((acc, tagGroup) => acc.concat(tagGroup.tags), []);

            return {
                tagGroups: tag_groups.items,
                tags,
                tagVersion: tag_groups.version,
            };
        }
        case L.asset_types:
            if (asset_types.not_changed)
                return {};
            return {
                assetTypes: asset_types.items,
                assetVersion: asset_types.version,
            };
        case L.fields:
            if (fields.not_changed)
                return {};

            writeStorage(StorageKey.cache_custom_fields, fields.items);
            return {
                fields: fields.items,
                fieldVersion: fields.version,
            };
        case L.number_formats:
            if (number_formats.not_changed)
                return {};
            return {
                numberFormats: number_formats.items,
                numberFormatsVersion: number_formats.version,
            };
        case L.locations:
            if (locations.not_changed)
                return {};
            return {
                locations: locations.items,
                locationVersion: locations.version,
            };
        case L.tax_codes:
            return {
                taxCodes: tax_codes.items,
            };
        case L.settings:
            if (settings.not_changed)
                return {};
            return {
                settings: settings.items,
                settingVersion: settings.version,
            };
        // case L.limits:
        //     return {
        //         limits: useDummyQuota ? SubscriptionQuotaDummy : limits,
        //     };
        case L.users:
            return {
                users: users.items,
            };
        case L.price_levels:
            if (price_levels.not_changed)
                return {};
            return {
                priceLevels: price_levels.items,
                priceLevelVersion: price_levels.version,
            };
        case L.payment_methods:
            if (payment_methods.not_changed)
                return {};
            return {
                paymentMethods: payment_methods.items,
                paymentMethodVersion: payment_methods.version,
            };
        case L.advisors:
            return {
                advisors: advisors.items,
            };
        case L.clients:
            return {
                clients: clients.items,
            };
        case L.product_list:
            if (product_list.not_changed)
                return {};
            return {
                productList: product_list.items,
                productListVersion: product_list.version,

                // // For legacy suppport (can remove once stable)
                // products: product_list.items,
                // productVersion: product_list.version,
            };
        case L.product_detail:
            return {
                productDetail: {
                    ...product_detail.item,
                    // used when creating/viewing bundle, to see if the previously read product detail is for SALE/PURCHASE
                    price_type: params.product_detail.type,
                },
                productDetailLastParams: { ...params.product_detail },

                // // For legacy suppport (can remove once stable)
                // product: product_detail.item,
                // productLastParams: { ...params.product_detail },
            };
        case L.product_detail_list:
            return {
                productDetailList: product_detail_list.items,
                productDetailListLastParams: { ...params.product_detail_list },
            };
        case L.product_groups:
            if (product_groups.not_changed)
                return {};
            return {
                productGroups: product_groups.items,
                productGroupVersion: product_groups.version,
            };
        case L.classification_code_list:
            return {
                classificationCodeList: classification_code_list.items,
            };
        case L.form_designs:
            if (form_designs.not_changed)
                return {};
            return {
                formDesigns: form_designs.items,
                formDesignsVersion: form_designs.version,
            };
        case L.flow_streams:
            return {
                flowStreams: useDummyFlowStreamsListV2 ? flowStreamsListV2 : flow_streams,
            };
        default:
            return {};
    }
}
